// Feature Toggles with Unleash
import { Dispatch } from 'redux';

import { get, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;

export interface FeatureToggleStartedAction extends Action<typeof actionTypes.FEATURE_TOGGLE_STARTED> {
    type: typeof actionTypes.FEATURE_TOGGLE_STARTED;
}

export interface FeatureToggleFulfilledAction extends Action<typeof actionTypes.FEATURE_TOGGLE_FULFILLED> {
    type: typeof actionTypes.FEATURE_TOGGLE_FULFILLED;
    payload: any;
}

export interface FeatureToggleFailedAction extends Action<typeof actionTypes.FEATURE_TOGGLE_FAILED> {
    type: typeof actionTypes.FEATURE_TOGGLE_FAILED;
    payload: RequestExceptionWithResponse;
}

export type FeatureToggleActions =
    FeatureToggleStartedAction | FeatureToggleFulfilledAction | FeatureToggleFailedAction;

export const featureToggleStarted = (): FeatureToggleStartedAction => ({
    type: actionTypes.FEATURE_TOGGLE_STARTED,
});
export const featureToggleFulfilled = (json: any): FeatureToggleFulfilledAction => ({
    type: actionTypes.FEATURE_TOGGLE_FULFILLED,
    payload: json,
});
export const featureToggleFailed = (error: RequestExceptionWithResponse): FeatureToggleFailedAction => ({
    type: actionTypes.FEATURE_TOGGLE_FAILED,
    payload: error,
});

export const featureToggle = async (
    featureName: string,
    dispatch: Dispatch<AppActions>,
    bankregnr: string | null,
): Promise<boolean> => {
    const toCamelCase = (str: string) => str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    try {
        dispatch(featureToggleStarted());
        const response: boolean = await get(
            `${actionTypes.RESOURCE_PATH}/feature/${featureName}`,
            getRequestHeaders(bankregnr),
        );
        dispatch(featureToggleFulfilled({ [toCamelCase(featureName)]: response }));
        return response;
    } catch (error) {
        dispatch(featureToggleFailed(error));
    }
    return false;
};
